import React from 'react';
import { CurrentList, ReceiptStatus } from '../../../../apiServices/types';
import { formatCurrency } from '../../../../utils';

export interface ExpensesSummaryProps {
  currentList: CurrentList;
  categoryTotals: Record<string, number>;
  grandTotal: number;
  receiptStatus?: unknown;
  onSubmit: () => void;
  isSubmitting?: boolean;
  clientVersion?: number;
  serverVersion?: number;
}

const ExpensesSummary: React.FC<ExpensesSummaryProps> = ({
  currentList,
  categoryTotals,
  grandTotal,
  receiptStatus,
  onSubmit,
  isSubmitting = false,
  clientVersion = 0,
  serverVersion = 0
}) => {
  const isCompletedStatus = (status: unknown): boolean => {
    if (typeof status === 'string') return status === 'Completed';
    return Number(status) === ReceiptStatus.Completed;
  };

  // Перевірити чи очікує синхронізації (clientVersion > serverVersion)
  const hasPendingSync = clientVersion > serverVersion && clientVersion > 0 && serverVersion > 0;

  return (
    <div className="summary-section expenses-summary">
      <h3 className="summary-title">Підсумок витрат</h3>
      {Object.entries(currentList.categories).map(([categoryId, category]) => {
        const hasBoughtItems = category.items.some(item => item.checked);
        const categoryTotal = categoryTotals[categoryId] || 0;
        
        return category.name && hasBoughtItems && categoryTotal > 0 && (
          <div key={categoryId} className="summary-item">
            <span className="summary-label">{category.name}:</span>
            <span className="summary-value">{formatCurrency(categoryTotal)}</span>
          </div>
        );
      })}
      <div className="summary-item">
        <span className="summary-label">Загалом:</span>
        <span className="summary-value">{formatCurrency(grandTotal)}</span>
      </div>
      <button 
        className="btn btn-primary btn-full mt-lg submit-receipt-btn" 
        onClick={onSubmit}
        disabled={isCompletedStatus(receiptStatus) || isSubmitting || hasPendingSync}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
        <span>
          {isSubmitting ? 'Збереження...' : 
           isCompletedStatus(receiptStatus) ? 'Чек завершено' : 'Завершити чек'}
        </span>
      </button>
    </div>
  );
};

export default ExpensesSummary;
